export const eventNamespace = 'sharedEvents'

// Attribute Constants

export const RASTER: Record<string, boolean> = {
  roguetexturedblackpowdercoat     : true,
  tekgraycamo                      : true,
  tigerstripewoodlandcamo          : true,
  stainlesssteel                   : true,
  texturedblacknonnumbereduprights : true,
  bronze                           : true,
  gold                             : true,
  satinclear                       : true,
  texturedblack                    : true,
  texturedred                      : true,
  texturedcharcoalgray             : true,
  textureddarkblue                 : true,
  cerakoteblack                    : true,
  black                            : true,
  bionicblue                       : true,
  gauntletgray                     : true,
  poppinpink                       : true,
  sniper                           : true,
  kraiburgrubber                   : true,
  greenturf                        : true,
  redtrack                         : true,
  standard                         : true,
  truetouch                        : true,
  silver                           : true,
  rogue                            : true,
  barbellclub20                    : true,
  barbellskull                     : true,
  dontweaken                       : true,
}

export const KNURLRASTER: Record<string, boolean> = {
  black          : true,
  blue           : true,
  neongreen      : true,
  pink           : true,
  gunmetal       : true,
  red            : true,
  stainlesssteel : true,
  rawaluminum    : true,
}

export const HARDCODE: Record<string, string> = {
  'satinblack/stainlesssteel'          : '/UI/swatches/mg-black-stainless',
  'texturedblack/stainlesssteel'       : '/UI/swatches/txt-black-stainless',
  'texturedcharcoalgray/texturedblack' : '/UI/swatches/txt-gray-txt-black',
}

export const SVG: Record<string, string> = {
  mass_height : 'attributes',
  rig_length  : 'attributes',
  mass_width  : 'attributes',
  edition     : 'attributes',
  team        : 'nfl',
}

export const COLORS: Record<string, string> = {
  black         : '#000000',
  blackzinc     : '#050606',
  chrome        : '#bebfbe',
  blue          : '#004D7B',
  deserttan     : '#bdaa93',
  gray          : '#444444',
  green         : '#738E3B',
  lightblue     : '#236788',
  maroon        : '#521711',
  navy          : '#212b33',
  olivedrab     : '#4A4633',
  darkolive     : '#4A4633',
  odgreen       : '#4A4633',
  orange        : '#CC4622',
  pink          : '#D44F80',
  purple        : '#59436A',
  red           : '#AB1310',
  rogueclear    : '#e7e7e6',
  brightzinc    : '#a8a8a8',
  brightblue    : '#2b59bb',
  blackcerakote : '#000000',
  brightgreen   : '#79bb2f',
  darkblue      : '#13273a',
  darknavy      : '#13273a',
  burntorange   : '#ea6524',
  darkred       : '#7f252b',
  gunmetal      : '#616161',
  roguered      : '#b60713',
  satinblack    : '#000000',
  lightgray     : '#999999',
  lightgrey     : '#5b5b5b',
  yellow        : '#ceb501',
  white         : '#ffffff',
}
